import { SharedConstants } from "../../../../shared/constants/shared.constants";
export class CreateApplicationLocationRcConstants {
    static STEP_TITLE = "Location";
    static OWNER_LABEL = "Owners";
    static REMOVE_PROPERTY_LABEL = "Remove property";
    static DESCRIPTION_LABEL_1 = "Search the map to find the property for which you are lodging an application, using the 'Find address or place' search bar.";
    static DESCRIPTION_LABEL_2 = "Zoom in close enough to the correct property and click on the property. Click on 'add property' in the window that appears on the map after you selected the property.";
    static DESCRIPTION_LABEL_3 = "The property will be added and the fields must be completed for the property. Please note that multiple properties may be added.";
    static DESCRIPTION_LABEL_4 = "Please note that the zoning here is the current zoning of the property. Please note that an owner should be added for each property (this is linked to the property and the application).";
    static ERF_NO_CONTROL = "erfNo";
    static SUBDIVISION_CONTROL = "subdivision";
    static FARM_NO_CONTROL = "farmNo";
    static ALLOTMENT_CONTROL = "allotment";
    static SG_CODE_CONTROL = "sgCode";
    static ADDRESS_CONTROL = "address";
    static OWNER_CONTROL = "owners";
    static TITLE_DEED_NUMBER_CONTROL = "titleDeedNumber";
    static ZONING_CONTROL = "zoning";
    static SECTIONAL_TITLE_SCHEME_NAME_CONTROL = "sectionalTitleSchemeName";
    static SECTIONAL_TITLE_SCHEME_NUMBER_CONTROL = "sectionalTitleSchemeNumber";
    static SECTIONAL_TITLE_SCHEME_UNIT_CONTROL = "sectionalTitleSchemeUnit";
    static EXTENT_CONTROL = "extent";
    static PURCHASE_PRICE_CONTROL = "purchasePrice";
    static DATE_OF_SALE_CONTROL = "dateOfSale";
    static ELECTRICITY_ACCOUNT_NUMBER_CONTROL = "electricityAccountNumber";
    static WATER_ACCOUNT_NUMBER_CONTROL = "waterAccountNumber";
    static REFUSE_ACCOUNT_NUMBER_CONTROL = "refuseAccountNumber";
    static MANAGING_AGENT_CONTROL = "managingAgent";
    static ERF_NO_TEXT_PLACEHOLDER = "Erf no";
    static SUBDIVISION_TEXT_PLACEHOLDER = "Subdivision / portion number";
    static FARM_NO_TEXT_PLACEHOLDER = "Farm no";
    static ALLOTMENT_TEXT_PLACEHOLDER = "Allotment / suburb";
    static SG_CODE_TEXT_PLACEHOLDER = "SG Code";
    static ADDRESS_TEXT_PLACEHOLDER = "Address";
    static TITLE_DEED_NUMBER_LABEL = "Title deed number";
    static ZONING_LABEL = "Zoning";
    static SECTIONAL_TITLE_SCHEME_NAME_LABEL = "Sectional title scheme name";
    static SECTIONAL_TITLE_SCHEME_NUMBER_LABEL = "Sectional title scheme number";
    static SECTIONAL_TITLE_SCHEME_UNIT_LABEL = "Sectional title scheme unit";
    static EXTENT_LABEL = "Extent";
    static PURCHASE_PRICE_LABEL = "Purchase price";
    static DATE_OF_SALE_LABEL = "Date of sale";
    static ELECTRICITY_ACCOUNT_NUMBER_LABEL = "Electricity account number";
    static WATER_ACCOUNT_NUMBER_LABEL = "Water account number";
    static REFUSE_ACCOUNT_NUMBER_LABEL = "Refuse account number";
    static MANAGING_AGENT_LABEL = "Managing agent";
    static DUPLICATE_MESSAGE = "The selected property has already been added";
    static TRUE_CENTROID = "True centroid gp shared-services";
    static ONLY_ONE_PROPERTY_ALLOWED = "Only one property can be added per application.";
    static INVALID_OWNER_ATTRIBUTE = "Some owner attribute(s) is missing on the property owner layer. Please contact your systems administrator.";
    static INVALID_ZONING_ATTRIBUTE = "Zoning attribute is missing on the property zoning layer. Please contact your systems administrator.";
    static ZONING_NOT_FOUND = "The found zone ({0}) has not been configured in the lookups. Please contact your systems administrator.";
    static MODAL_OPTION = {
        size: SharedConstants.MODAL_SIZE.extraLarge,
        centered: true,
        backdrop: "static",
        keyboard: false
    };
    static VALIDATION_MESSAGES = {
        erfNo: {
            required: `Erf no ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        subdivision: {
            required: `Subdivision ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        allotment: {
            required: `Allotment ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        farmNo: {
            required: `Farm no ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        sgCode: {
            required: `SG code ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        address: {
            required: `Address ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        titleDeedNumber: {
            required: `Title deed number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        zoning: {
            required: `Zoning ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        sectionalTitleSchemeName: {
            required: `Sectional title scheme name ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        sectionalTitleSchemeNumber: {
            required: `Sectional title scheme number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        sectionalTitleSchemeUnit: {
            required: `Sectional title scheme unit ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        extent: {
            required: `Extent ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        purchasePrice: {
            required: `Purchase price ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        dateOfSale: {
            required: `Date of sale ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        electricityAccountNumber: {
            required: `Electricity account number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        waterAccountNumber: {
            required: `Water account number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        refuseAccountNumber: {
            required: `Refuse account number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        managingAgent: {
            required: `Managing agent ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }
    };
    static PROPERTY_REQUIRED = "Please select a property before continuing with the create application process";
}
